// extracted by mini-css-extract-plugin
export var modal = "_hc-0";